import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ND } from '@pt/pt-models';

@Pipe({
  name: 'latestChangeDate',
  pure: false
})
export class LatestChangeDatePipe implements PipeTransform {
  dayAgo;
  daysAgo;
  hourAgo;
  hoursAgo;
  minuteAgo;
  minutesAgo;
  fewSecondsAgo;
  ND = ND;

  private MINUTE = 1000 * 60;
  private HOUR = this.MINUTE * 60;
  private DAY = this.HOUR * 24;

  constructor(private translateService: TranslateService) {
    translateService.stream('LABELS.DAY_AGO').subscribe(
      (response) => this.dayAgo = response
    );
    translateService.stream('LABELS.DAYS_AGO').subscribe(
      (response) => this.daysAgo = response
    );
    translateService.stream('LABELS.HOUR_AGO').subscribe(
      (response) => this.hourAgo = response
    );
    translateService.stream('LABELS.HOURS_AGO').subscribe(
      (response) => this.hoursAgo = response
    );
    translateService.stream('LABELS.MINUTE_AGO').subscribe(
      (response) => this.minuteAgo = response
    );
    translateService.stream('LABELS.MINUTES_AGO').subscribe(
      (response) => this.minutesAgo = response
    );
    translateService.stream('LABELS.FEW_SECOND_AGO').subscribe(
      (response) => this.fewSecondsAgo = response
    );
  }

  transform(value: number): string {
    if (value !== null && value !== undefined) {
      const currentDate = Date.now();
      const valueDate = new Date(value);
      const diff = currentDate - valueDate.getTime();
      if (diff > 0) {

        if (diff >= this.DAY) {
          const diffDay = Math.floor(diff / this.DAY);
          if (diffDay > 1) {
            return diffDay + ' ' + this.daysAgo;
          }
          return diffDay + ' ' + this.dayAgo;
        }

        if (diff >= this.HOUR) {
          const diffHour = Math.floor(diff / this.HOUR);
          if (diffHour > 1) {
            return diffHour + ' ' + this.hoursAgo;
          }
          return diffHour + ' ' + this.hourAgo;
        }

        if (diff >= this.MINUTE) {
          const diffMinute = Math.floor(diff / this.MINUTE);
          if (diffMinute > 1) {
            return diffMinute + ' ' + this.minutesAgo;
          }
          return diffMinute + ' ' + this.minuteAgo;
        }
        return this.fewSecondsAgo;

      }
    }
    return this.ND;
  }

}
